module.exports = __webpack_public_path__ + "img/trunk_11x2_z16.e020c0e4.svg";